import React, { FunctionComponent } from 'react';

import {
  ActionBarRow,
  ActionBarLine,
  PrimaryAction,
  SecondaryAction,
  ActionBarWrapper,
} from './styles';

interface Action {
  label: string;
  disabled?: boolean;
  onClick: () => void;
  tabIndex?: number;
}

interface ActionBarProps {
  primaryAction: Action;
  secondaryAction?: Action;
}

const ActionBar: FunctionComponent<ActionBarProps> = ({
  primaryAction,
  secondaryAction,
}) => (
  <ActionBarWrapper>
    <ActionBarLine />
    <ActionBarRow hasBothActions={!!secondaryAction}>
      {secondaryAction && (
        <SecondaryAction
          tabIndex={secondaryAction.tabIndex || -1}
          onClick={secondaryAction.onClick}
          disabled={secondaryAction.disabled}
        >
          {secondaryAction.label}
        </SecondaryAction>
      )}
      <PrimaryAction
        onClick={primaryAction.onClick}
        tabIndex={primaryAction.tabIndex || -1}
        disabled={primaryAction.disabled}
      >
        {primaryAction.label}
      </PrimaryAction>
    </ActionBarRow>
  </ActionBarWrapper>
);

export default ActionBar;
